import React, { Fragment } from 'react'
const PageBannerAction = props => {
  const { children } = props
  return <Fragment>{children}</Fragment>
}
export default PageBannerAction
